import { Text, type TextProps } from '@mantine/core'
import { formatMoney } from '../../lib/currency'

interface Props extends TextProps {
  amount: number | string | null | undefined
  currency?: string | null
  fallback?: string
}

/**
 * Renders an amount in its native currency. For pure IDR usage keep
 * the existing CurrencyText component; for new financial UI (anything
 * that touches Invoice / Quote / Contract / Payment) prefer MoneyText
 * so the document currency surfaces correctly.
 */
export function MoneyText({ amount, currency = 'IDR', fallback = '-', ...rest }: Props) {
  return <Text {...rest}>{formatMoney(amount, currency, fallback)}</Text>
}
